import { useEffect, useState } from 'react';
import './App.css';
import './global/table.css';
// import tablecss from './global/table.css'
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Login } from './view/Login';
import { ResetPass } from './view/ResetPass';
import { Home } from './view/Home';
import { Dashboard } from './view/Dashboard';
import { ProtectedRoute } from './components/ProtectedRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { roleAccess, companyConfig, setUser, setUserSub, subscription } from './reducers/authSlice';
import ProductList from './view/Products/ProductList';
import ProductListWCA from './view/WCA/WCAProducts/ProductList';
import Orders from './view/Orders';
import Enquiries from './view/Enquiries';
import CategoryList from './view/Categories/CategoryList';
import CustomerList from './view/Customer/CustomerList';
import UserProfile from './view/UserProfile';
import PaymentHistory from './view/PaymentHistory';
import Campaigns from './view/Campaigns';
import ScheduleCampaigns from './view/ScheduleCampaigns';
import parseJwt from './utils/authUtils';
import CampaignDetails from './view/CampaignDetails';
import RunCampaigns from './view/RunCampaigns';
import RunCampaignWCA from './view/WCA/WcaRunCampaign';
import { CampaignCustomer } from './view/RunCampaigns/Customers';
import { CampaignCustomerWCA } from './view/WCA/WcaRunCampaign/Customers';
import ScheduleCamp from './view/RunCampaigns/ScheduleCamp';
import ScheduleCampWCA from './view/WCA/WcaRunCampaign/ScheduleCamp';
import { ProductSelect } from './view/RunCampaigns/ProductSelect';
import { ProductSelectWCA } from './view/WCA/WcaRunCampaign/ProductSelect';
import { SelectTemplate } from './view/RunCampaigns/SelectTemplate';
import { SelectTemplateWCA } from './view/WCA/WcaRunCampaign/SelectTemplate';
import AccountSettings from './view/AccountSettings';
import User from './view/AccountSettings/User';
import NewProduct from './view/Products/NewProduct';
import Products from './view/Products';
import ChatEnq from './view/ChatEnq/Index';
import NewCustomer from './view/Customer/NewCustomer';
import Customer from './view/Customer';
import NewGroup from './view/Customer/NewGroup';
import RoleBasedRoute from './components/ProtectedRoutes/RoleBasedRoute';
import Unauthorized from './view/Unauthorized';
import GroupList from './view/Customer/GroupList';
// import { setupRequestInterceptor } from './api/axios.instance';
import { setupWcaRequestInterceptor } from './api/axios.wcaInstance';
import Recharge from './view/Recharge';
import QuickNoteForm from './view/AccountSettings/TextAutomation/QuickNoteForm';
import Tickets from './view/Tickets';
import ImageInventory from './view/ImageInventory';
import PageNotFound from './view/PageNotFound';
import OrderDetails from './view/Orders/OrderDetails';
import BotFlow from './view/BotFlow/BotFlow';
import BotFlowList from './view/BotFlow/BotFlowList';
import NewBotFlow from './view/BotFlow/NewBotFlow';
import Subscription from './view/Subscription';
import TermsNdConditions from './view/Terms&Conditions/Terms&Conditions';
import { v4 as uuidv4 } from 'uuid';
import Usage from './view/Usage';
import MarketPlace from './view/MarketPlace';
import ZOHO from './view/MarketPlace/Zoho';
import MeetingScheduler from './view/MeetingScheduler';
import NewMeetingForm from './view/MeetingScheduler/NewMeetingForm';
import ViewDetails from './view/MeetingScheduler/ViewDetails';
import EditMeeting from './view/MeetingScheduler/EditMeeting';
import { useUtility } from './context/UtilityContext';
import AiAgent from './view/ai';
import AgentCreate from './view/ai/AgentCreate';
import { useSocket } from './hooks/useSocket';
import CampaignTemplateList from './view/CampaignTemplate/CampaignTemplateList';
import NewCampaignTemplate from './view/CampaignTemplate/NewCampaignTemplate';
import CampaignTemplate from './view/CampaignTemplate/CampaignTemplate';
import TemplateLibrary from './view/CampaignTemplate/TemplateLibrary';
import WcaCampaign from './view/WCA/WCACampaign';
import CallModule from './view/WcaEnqChat/Callsupport/CallModule';
import AppCampaign from './view/AppCampaign/AppCampaign';
import AppCampaignDetails from './view/AppCampaign/AppCampaignDetails';
import TelegramBotConfigs from './view/MarketPlace/Telegram';
import TelegramChat from './view/Telegram';
import { fetchAllMetadata } from './reducers/MetaData/metadata-actions';
import MetadataManagement from './view/MarketPlace/MetadataOnboarding';
import MetaDataInfo from './view/MarketPlace/MetadataOnboarding/MetaDataInfo';
import ComponentResolver from './components/component-resolver';
import NewProductWCA from './view/WCA/WCAProducts/NewProduct';
import HelpSupport from './view/Help&Support';
import TicketDetail from './view/Help&Support/TicketDetail';
function App() {
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.authenticate.user?.companyId);
  const { metadataList } = useSelector((state) => state.metadata);
  const userSubscription = JSON.parse(localStorage.getItem('userSub'));
  let companyKey = JSON.parse(localStorage.getItem('companykey'));
  const token = localStorage.getItem('token');
  const userSub = localStorage.getItem('userSub');
  const sessionID = localStorage.getItem('sessionID');
  const { selectedMetadataId, setSelectedMetadataId } = useUtility();
  const { socket, isConnected } = useSocket(companyId);

  let user = null;
  if (!sessionID) {
    localStorage.setItem('sessionID', uuidv4());
  }

  useEffect(() => {
    if (!token) return;

    const user = parseJwt(token);
    dispatch(setUser(user));
  }, [token, dispatch]);

  useEffect(() => {
    if (!userSub) return;
    const sub = JSON.parse(userSub);
    dispatch(setUserSub({ subscription: sub }));
  }, [userSub, dispatch]);

  useEffect(() => {
    if (!userSubscription) return;

    dispatch(setUserSub({ subscription: userSubscription }));
  }, [userSubscription, dispatch]);

  useEffect(() => {
    if (!companyId) return;

    dispatch(subscription(companyId));
  }, [companyId, dispatch]);

  let localInterceptorId = null;
  let wcaInterceptorId = null;

  // ✅ Setup interceptors AFTER companyId exists
  useEffect(() => {
    if (!companyId) return;

    // setupRequestInterceptor({ companyId });
    setupWcaRequestInterceptor({ companyId });
  }, [companyId]);

  useEffect(() => {
    if (token) {
      dispatch(companyConfig());
    }
  }, [companyId]);

  useEffect(() => {
    if (!companyId) return;
    dispatch(fetchAllMetadata({ page: 0, limit: 50 })).unwrap();
  }, [companyId, dispatch]);

  // ✅ Select default metadata
  useEffect(() => {
    if (!metadataList.length) return;

    const exists = metadataList.some(
      (meta) => String(meta.id) === String(selectedMetadataId)
    );

    if (!exists) {
      setSelectedMetadataId(String(metadataList[0].id));
    }
  }, [metadataList, selectedMetadataId]);

  useEffect(() => {
    if (!socket) return;

    const handleConnect = () => console.log('✅ Socket connected:');
    socket.on('connect', handleConnect);

    return () => socket.off('connect', handleConnect);
  }, [socket]);

  // useEffect(() => {
  //   const initFB = () => {
  //     if (window.FB) {
  //       window.FB.init({
  //         appId: process.env.REACT_APP_FACEBOOK_APP_ID,
  //         autoLogAppEvents: true,
  //         xfbml: true,
  //         version: 'v23.0',
  //       });
  //     }
  //   };

  //   if (window.FB) {
  //     initFB();
  //   } else {
  //     window.fbAsyncInit = initFB;
  //   }
  // }, []);

  return (
    <div className="App">
      <CallModule />
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home interceptorId={localInterceptorId} wcaInterceptorId={wcaInterceptorId} />
            </ProtectedRoute>
          }
        >
          <Route
            path="dashboard"
            element={
              <RoleBasedRoute location={'dashboard'} permission={'read'}>
                <Dashboard />
              </RoleBasedRoute>
            }
          />
          <Route
            path="campaigns"
            element={
              <RoleBasedRoute location={'campaign'} permission={'read'}>
                {/* <Campaigns /> */}
                <AppCampaign />
              </RoleBasedRoute>
            }
          >
            <Route
              path=":id"
              element={
                <RoleBasedRoute location={'campaign'} permission={'read'}>
                  {/* <CampaignDetails /> */}
                  <AppCampaignDetails />
                </RoleBasedRoute>
              }
            ></Route>
          </Route>
          <Route
            path="meeting"
            element={
              <RoleBasedRoute location={'campaign'} permission={'read'}>
                <MeetingScheduler />
              </RoleBasedRoute>
            }
          />
          <Route
            path="meeting/new"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <NewMeetingForm />
              </RoleBasedRoute>
            }
          />
          <Route
            path="meeting/:id"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ViewDetails />
              </RoleBasedRoute>
            }
          />
          <Route
            path="meeting/:id/edit"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <EditMeeting />
              </RoleBasedRoute>
            }
          />
          <Route
            path="schedule"
            element={
              <RoleBasedRoute location={'campaign'} permission={'read'}>
                <ScheduleCampaigns />
              </RoleBasedRoute>
            }
          />
          <Route
            path="chat"
            element={
              <RoleBasedRoute location={'sales'} permission={'read'}>
                <ChatEnq />
              </RoleBasedRoute>
            }
          />

          <Route
            path="chat/:mob"
            element={
              <RoleBasedRoute location={'sales'} permission={'read'}>
                <ChatEnq />
              </RoleBasedRoute>
            }
          />

          <Route path="products" element={<Products />}>
            <Route
              path="list"
              element={
                <RoleBasedRoute location={'product'} permission={'read'}>
                  <ComponentResolver defaultComponent={ProductList} wcaComponent={ProductListWCA} />
                  {/* <ProductList /> */}
                </RoleBasedRoute>
              }
            />
            <Route
              path="new"
              element={
                <RoleBasedRoute location={'product'} permission={'create'}>
                  <ComponentResolver defaultComponent={NewProduct} wcaComponent={NewProductWCA} />

                  {/* <NewProduct /> */}
                </RoleBasedRoute>
              }
            />
            <Route
              path=":id/update"
              element={
                <RoleBasedRoute location={'product'} permission={'update'}>
                  <ComponentResolver defaultComponent={NewProduct} wcaComponent={NewProductWCA} />
                  {/* <NewProduct /> */}
                </RoleBasedRoute>
              }
            />
          </Route>
          <Route
            path="orders"
            element={
              <RoleBasedRoute location={'order'} permission={'read'}>
                <Orders />
              </RoleBasedRoute>
            }
          >
            <Route
              path=":id"
              element={
                <RoleBasedRoute location={'order'} permission={'update'}>
                  <OrderDetails />
                </RoleBasedRoute>
              }
            />
          </Route>

          <Route
            path="mediaInventory"
            element={
              <RoleBasedRoute location={'product'} permission={'read'}>
                <ImageInventory />
              </RoleBasedRoute>
            }
          />
          <Route
            path="ticket"
            element={
              <RoleBasedRoute location={'ticket'} permission={'read'}>
                <Tickets />
              </RoleBasedRoute>
            }
          />

          <Route
            path="runcampaign/new"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={SelectTemplate}
                  wcaComponent={SelectTemplateWCA}
                />
                {/* <SelectTemplate /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selecttemplate/new"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver defaultComponent={RunCampaigns} wcaComponent={RunCampaignWCA} />
                {/* <RunCampaigns /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selectproducts/new"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={ProductSelect}
                  wcaComponent={ProductSelectWCA}
                />
                {/* <ProductSelect /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selectcustomer/new"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={CampaignCustomer}
                  wcaComponent={CampaignCustomerWCA}
                />

                {/* <CampaignCustomer /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/schedule/new"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver defaultComponent={ScheduleCamp} wcaComponent={ScheduleCampWCA} />
                {/* <ScheduleCamp /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/:id"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={SelectTemplate}
                  wcaComponent={SelectTemplateWCA}
                />
                {/* <SelectTemplate /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selecttemplate/:id"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver defaultComponent={RunCampaigns} wcaComponent={RunCampaignWCA} />
                {/* <RunCampaigns /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selectproducts/:id"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={ProductSelect}
                  wcaComponent={ProductSelectWCA}
                />
                {/* <ProductSelect /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selectcustomer/:id"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={CampaignCustomer}
                  wcaComponent={CampaignCustomerWCA}
                />

                {/* <CampaignCustomer /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/schedule/:id"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver defaultComponent={ScheduleCamp} wcaComponent={ScheduleCampWCA} />
                {/* <ScheduleCamp /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/:id/:mode"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={SelectTemplate}
                  wcaComponent={SelectTemplateWCA}
                />
                {/* <SelectTemplate /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selecttemplate/:id/:mode"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver defaultComponent={RunCampaigns} wcaComponent={RunCampaignWCA} />
                {/* <RunCampaigns /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selectproducts/:id/:mode"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={ProductSelect}
                  wcaComponent={ProductSelectWCA}
                />
                {/* <ProductSelect /> */}
              </RoleBasedRoute>
            }
          />
          <Route
            path="runcampaign/selectcustomer/:id/:mode"
            element={
              <RoleBasedRoute location={'campaign'} permission={'create'}>
                <ComponentResolver
                  defaultComponent={CampaignCustomer}
                  wcaComponent={CampaignCustomerWCA}
                />

                {/* <CampaignCustomer /> */}
              </RoleBasedRoute>
            }
          />

          <Route
            path="enquries"
            element={
              <RoleBasedRoute location={'enquires'} permission={'read'}>
                <Enquiries />
              </RoleBasedRoute>
            }
          />

          <Route
            path="categories/list"
            element={
              <RoleBasedRoute location={'category'} permission={'read'}>
                <CategoryList />
              </RoleBasedRoute>
            }
          />

          <Route
            path="userprofile"
            element={
              <RoleBasedRoute location={'user'} permission={'read'}>
                <UserProfile />
              </RoleBasedRoute>
            }
          />
          <Route
            path="paymenthistory"
            element={
              <RoleBasedRoute location={'payment'} permission={'read'}>
                <PaymentHistory />
              </RoleBasedRoute>
            }
          />
          <Route
            path="account"
            element={
              <RoleBasedRoute location={'account'} permission={'read'}>
                <AccountSettings />
              </RoleBasedRoute>
            }
          />
          <Route
            path="account/new/:id"
            element={
              <RoleBasedRoute location={'account'} permission={'read'}>
                <User />
              </RoleBasedRoute>
            }
          />
          <Route
            path="account/:id"
            element={
              <RoleBasedRoute location={'account'} permission={'read'}>
                <User />
              </RoleBasedRoute>
            }
          />
          <Route
            path="account/quick-notes/new"
            element={
              <RoleBasedRoute location={'textAutomation'} permission={'read'}>
                <QuickNoteForm />
              </RoleBasedRoute>
            }
          />
          <Route
            path="account/quick-notes/:id"
            element={
              <RoleBasedRoute location={'textAutomation'} permission={'read'}>
                <QuickNoteForm />
              </RoleBasedRoute>
            }
          />
          <Route
            path="customers"
            element={
              <RoleBasedRoute location={'customer'} permission={['read', 'create']} condition="OR">
                <Customer />
              </RoleBasedRoute>
            }
          >
            <Route
              path="list"
              element={
                <RoleBasedRoute
                  location={'customer'}
                  permission={['read', 'create']}
                  condition="OR"
                >
                  <CustomerList />
                </RoleBasedRoute>
              }
            />
            <Route
              path="new"
              element={
                <RoleBasedRoute
                  location={'customer'}
                  permission={['read', 'create']}
                  condition="OR"
                >
                  <NewCustomer />
                </RoleBasedRoute>
              }
            />
            <Route
              path=":id/update"
              element={
                <RoleBasedRoute
                  location={'customer'}
                  permission={['create', 'update']}
                  condition="OR"
                >
                  <NewCustomer />
                </RoleBasedRoute>
              }
            />
            <Route
              path="gnew"
              element={
                <RoleBasedRoute location={'customerGroup'} permission={'create'}>
                  <NewGroup />
                </RoleBasedRoute>
              }
            />
            <Route
              path=":id/gupdate"
              element={
                <RoleBasedRoute location={'customerGroup'} permission={'update'}>
                  <NewGroup />
                </RoleBasedRoute>
              }
            />
          </Route>
          <Route
            path="customers/groups"
            element={
              <RoleBasedRoute location={'customerGroup'} permission={'read'}>
                <GroupList />
              </RoleBasedRoute>
            }
          />
          <Route
            path="customers/groups/:id"
            element={
              <RoleBasedRoute location={'customerGroup'} permission={'read'}>
                <GroupList />
              </RoleBasedRoute>
            }
          />

          <Route
            path="campaign-templates"
            element={
              <RoleBasedRoute location={'template'} permission={'read'}>
                <CampaignTemplate />
              </RoleBasedRoute>
            }
          >
            <Route
              path="list"
              element={
                <RoleBasedRoute location={'template'} permission={'read'}>
                  <CampaignTemplateList />
                </RoleBasedRoute>
              }
            />
            <Route
              path="new"
              element={
                <RoleBasedRoute location={'template'} permission={'create'}>
                  <NewCampaignTemplate />
                </RoleBasedRoute>
              }
            />
            <Route
              path="template-library"
              element={
                <RoleBasedRoute location={'template'} permission={'read'}>
                  <TemplateLibrary />
                </RoleBasedRoute>
              }
            />
            <Route
              path=":id/update"
              element={
                <RoleBasedRoute location={'template'} permission={'update'}>
                  <NewCampaignTemplate />
                </RoleBasedRoute>
              }
            />
            <Route
              path=":id/clone"
              element={
                <RoleBasedRoute location={'template'} permission={'create'}>
                  <NewCampaignTemplate />
                </RoleBasedRoute>
              }
            />
          </Route>
          <Route
            path="dashboard/recharge"
            element={
              <RoleBasedRoute location={'payment'} permission={'create'}>
                <Recharge />
              </RoleBasedRoute>
            }
          />
          <Route
            path="dashboard/subscription"
            element={
              <RoleBasedRoute location={'payment'} permission={'create'}>
                <Subscription />
              </RoleBasedRoute>
            }
          />
          <Route path="bots" element={<BotFlow />}>
            <Route
              path="list"
              element={
                <RoleBasedRoute location={'template'} permission={'read'}>
                  <BotFlowList />
                </RoleBasedRoute>
              }
            />
            <Route
              path="new"
              element={
                <RoleBasedRoute location={'template'} permission={'create'}>
                  <NewBotFlow />
                </RoleBasedRoute>
              }
            />
            <Route
              path=":id/update"
              element={
                <RoleBasedRoute location={'template'} permission={'update'}>
                  <NewBotFlow />
                </RoleBasedRoute>
              }
            />
          </Route>
          <Route
            path="/dashboard/:transactionid"
            element={
              <RoleBasedRoute location={'dashboard'} permission={'read'}>
                <Dashboard />
              </RoleBasedRoute>
            }
          />
          <Route
            path="marketplace/"
            element={
              <RoleBasedRoute
                location={'marketPlace'}
                permission={'read'}
                role={['superadmin', 'admin']}
              >
                <MarketPlace />
              </RoleBasedRoute>
            }
          />
          <Route
            path="marketplace/zoho"
            element={
              <RoleBasedRoute
                location={'marketPlace'}
                permission={'read'}
                role={['superadmin', 'admin']}
              >
                <ZOHO />
              </RoleBasedRoute>
            }
          />
          <Route
            path="marketplace/zoho/auth"
            element={
              <RoleBasedRoute
                location={'marketPlace'}
                permission={'read'}
                role={['superadmin', 'admin']}
              >
                <ZOHO />
              </RoleBasedRoute>
            }
          />
          <Route
            path="ai-agent/new"
            element={
              <RoleBasedRoute location={'ai'} permission={'read'}>
                <AgentCreate />
              </RoleBasedRoute>
            }
          />
          <Route
            path="ai-agent"
            element={
              <RoleBasedRoute location={'ai'} permission={'read'}>
                <AiAgent />
              </RoleBasedRoute>
            }
          />

          <Route
            path="marketplace/telegram"
            element={
              <RoleBasedRoute
                location={'marketPlace'}
                permission={'read'}
                role={['superadmin', 'admin']}
              >
                <TelegramBotConfigs />
              </RoleBasedRoute>
            }
          />
          <Route
            path="marketplace/metadata"
            element={
              <RoleBasedRoute
                location={'marketPlace'}
                permission={'read'}
                role={['superadmin', 'admin']}
              >
                <MetadataManagement />
              </RoleBasedRoute>
            }
          />
          <Route path="metadata/:metadataId" element={<MetaDataInfo />} />

          <Route path="telegram" element={<TelegramChat />} />
          <Route index path="usage" element={<Usage />} />
          <Route path="support" element={<HelpSupport />} />
          <Route path="support/tickets/:id" element={<TicketDetail />} />
        </Route>
        <Route index path="login" element={<Login />} />
        <Route index path="signup" element={<Login />} />
        {/* <Route index path="signup" element={<SignUp />} /> */}
        <Route path="terms&conditions" element={<TermsNdConditions />} />
        <Route path="/resetpass" element={<ResetPass />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
